<abc-drawer
  fxFill
  class="drawer"
  fxLayout="column"
  position="before"
  [closeOnOutsideClick]="shaderEnabled"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  (onOptionChanged)="onDrawerOptionChanged($event)"
  [(opened)]="menuOpened"
>
  <div *ngIf="visiblityDrawer" id="menu" fxLayout="column" content="abcDrawerContainer">
    <dx-toolbar fxLayout="row" id="navigation-header">
      <dxi-item location="left" cssClass="header-title" (click)="toggleMenu($event)">
        <img class="menu-open-logo" *ngIf="menuOpened; else elseBlock" src="{{ logoIcon }}" />
        <ng-template #elseBlock>
          <img *ngIf="logoMiniatureIcon" class="menu-closed-logo" src="{{ logoMiniatureIcon }}" />
        </ng-template>
      </dxi-item>
    </dx-toolbar>
    <div class="menu-container" fxLayout="column" fxFlex="calc(100% - 150px)">
      <div *ngIf="showNavigationBorder" class="border-bottom" fxFlex="13">
        <div
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
          [ngClass]="!menuOpened ? 'close-menu-tree-list' : 'open-menu-tree-list'"
          fxFill
        >
          <div fxLayout="row" fxLayoutAlign="center" fxFlex="15">
            <img class="company-logo" src="{{ logoNavigationBorder }}" (click)="onMenuItemClick($event)" />
          </div>

          <div class="text-container" fxFlex="85">
            <span class="layout-title-nav-style"> {{ navigationBorderFirstTitle }}</span>

            <span class="layout-title-nav-style">{{ navigationBorderSecondTitle }}</span>
          </div>
        </div>
      </div>
      <div class="menu-container">
        <ng-content select="[locationMenu]"></ng-content>
        <dx-tree-view
          #treeview
          class="menu-treeview"
          [ngStyle]="{ height: locationMenu ? 'calc(100% - 150px)' : 'calc(100% - 50px)' }"
          [ngClass]="!menuOpened ? 'close-menu-tree-list' : 'open-menu-tree-list'"
          [items]="navigationItems"
          keyExpr="path"
          selectionMode="single"
          [focusStateEnabled]="false"
          [displayExpr]="'text'"
          [itemsExpr]="'items'"
          expandEvent="click"
          width="100%"
          whiteSpace="normal"
          (onItemClick)="onMenuItemClick($event)"
        >
        </dx-tree-view>
      </div>
      <div fxLayout="column" fxLayoutAlign="center" [fxFlex]="flexValue">
        <div
          *ngIf="showLogout"
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
          [ngClass]="!menuOpened ? 'close-menu-tree-list' : 'open-menu-tree-list'"
        >
          <div fxLayout="row" fxLayoutAlign="center" fxFlex="15">
            <img class="company-logo" src="{{ logoutIcon }}" (click)="logout()" />
          </div>

          <div class="text-container" fxFlex="85">
            <span class="layout-title-nav-style">{{ logoutText }}</span>
          </div>
        </div>
        <div
          *ngIf="showToggleButton"
          [ngClass]="!menuOpened ? 'toggle-menu-btn-container-closed' : 'toggle-menu-btn-container-opened'"
          (click)="toggleMenu($event)"
        >
          <img class="toggle-menu-button" *ngIf="menuOpened" src="assets/images/PageMenu_close.svg" />

          <img class="toggle-menu-button" *ngIf="!menuOpened" src="assets/images/PageMenu_open.svg" />
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="column" class="app-container" id="container" content="abcDrawerContent">
    <header fxLayout="row" id="header">
      <dx-toolbar class="header-toolbar" fxLayout="column" fxLayoutAlign="center center">
        <dxi-item location="before">
          <dx-button mat-button class="menu-button" (click)="goBack()" *ngIf="showBackButton">
            <img class="menu-open" src="assets/images/arrowLeft.svg" />
          </dx-button>
          <button mat-button class="menu-button" (click)="toggleMenu($event)" *ngIf="showMenuToggleButton">
            <mat-icon class="menu-open-icon"> {{ 'menu' }}</mat-icon>
          </button>
        </dxi-item>
        <dxi-item location="before">
          <div class="border-left"></div>
        </dxi-item>

        <dxi-item *ngIf="visiblityLogo" location="before">
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="logo-icon" [svgIcon]="firstLogo"></mat-icon>
            <mat-icon class="logo-icon" [svgIcon]="secondLogo"></mat-icon>
          </div>
        </dxi-item>

        <dxi-item cssClass="title-style" location="before" style="width: 100%">
          <div fxLayout="column" fxLayoutAlign="center">
            <div fxLayout="row" fxLayoutAlign="flex-start center">
              <span class="address-style">{{ toolBarFirstTitle }}</span>
              <ng-content select="[toolBarFirstTitle]"></ng-content>
            </div>
            <div fxLayout="row" fxLayoutAlign="flex-start center">
              <span class="layout-title-style">{{ toolBarSecondTitle }}</span>
              <ng-content select="[toolBarSecondTitle]"></ng-content>
            </div>
          </div>
        </dxi-item>
        <dxi-item location="after" fxLayout="row" fxLayoutAlign="space-evenly">
          <ng-content select="[headerIcons]"></ng-content>
          <div class="user-info">
            <img *ngIf="userNotification" class="user-notification" src="assets/images/notification.svg" />

            <img *ngIf="userMessage" class="user-message" src="assets/images/comment.svg" />

            <img
              class="user-logo"
              [src]="
                userAvatar !== undefined && userAvatar !== null
                  ? 'data:image/png;base64,' + userAvatar
                  : 'assets/images/profile.svg'
              "
              (click)="onAvatarClick()"
            />
            <div class="user-name-bloc">
              <p class="user-name">{{ currentUserName | titlecase }}</p>
              <p class="user-function">{{ userFunction }}</p>
            </div>
            <mat-icon class="context-menu-icon custom-profile-context-menu" svgIcon="arrowDown"></mat-icon>
          </div>
        </dxi-item>
      </dx-toolbar>
      <dx-context-menu target=".custom-profile-context-menu" showEvent="dxclick" [items]="contextMenuItems">
      </dx-context-menu>
    </header>
    <ng-content> </ng-content>
  </div>
</abc-drawer>
